<template src="./RegisterComponent.html"></template>
<script>
import InputTextNormal from '@/components/inputs/input-text/normal/InputTextNormal.vue'
import InputPasswordNormal from '@/components/inputs/input-password/normal/InputPasswordNormal.vue'
import InputCheckboxOne from '@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue'
import ButtonLoginComponent from '@/components/buttons/button-login/ButtonLoginConponent.vue'
import {AppConstant} from "@/supports/app.constant.ts";
import {ref} from "vue";
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.ts";
import CommonService from "@/services/common.service.ts";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import InputDateTimeNormal from '@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue';
import { useCompanyStore } from '@/stores/company.js'
import ProgressBarNormal from "@/components/progress-bar/normal/ProgressBarNormal.vue";
import ButtonBackComponent from "@/components/buttons/button-back/ButtonBackComponent.vue";
import ButtonNextComponent from "@/components/buttons/button-next/ButtonNextComponent.vue";
import {useRoute} from "vue-router";
import ErrorMessageService from "@/services/error-message.service.ts";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import dayjs from "dayjs";
export default {
  name: 'RegisterComponent',
  components: {
    ButtonBackComponent,
    ProgressBarNormal,
    InputDateTimeNormal,
    SelectNormal,
    ButtonAddComponent,
    ButtonLoginComponent, 
    InputCheckboxOne, 
    InputTextNormal, 
    InputPasswordNormal,
    ButtonNextComponent,
    LoadingComponent,
  },
  setup() {
    const companyStore = useCompanyStore()
    const errors = ref(true)
    const labelBtnRegister = ref('Đăng kí')
    const labelBtnStep = ref('Đăng kí')
    const labelBtnStepBack = ref('Quay lại')
    const labelBtnStepNext = ref('Tiếp tục')
    const isLoading = ref(false)
    const dataRegister = ref({
      name_company: {
        id: 'name_company',
        label: 'Tên công ty',
        placeholder: 'Tên công ty',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
      code_company: {
        id: 'code_company',
        label: 'Mã công ty',
        placeholder: 'Mã công ty',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 7]]
      },
      email_company: {
        id: 'email_company',
        label: 'Email công ty',
        placeholder: 'Email công ty',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'email']
      },
      phone_company: {
        id: 'phone_company',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'phone']
      },
      addr_company: {
        id: 'addr_company',
        label: 'Địa chỉ công ty',
        placeholder: 'Địa chỉ công ty',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
      user_name: {
        id: 'user_name',
        label: 'Tên khách hàng',
        placeholder: 'Tên khách hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
      user_phone: {
        id: 'user_phone',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'phone']
      },
      user_email: {
        id: 'user_email',
        label: 'Email',
        placeholder: 'Email cá nhân',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'email']
      },
      user_password: {
        id: 'user_password',
        label: 'Mật khẩu',
        placeholder: 'Mật khẩu',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 32], ['minLength', 8]]
      },
      user_password_confirm: {
        id: 'user_password_confirm',
        label: 'Xác nhận mật khẩu',
        placeholder: 'Mật khẩu',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 32], ['minLength', 8]]
      },
      user_gender: {
        id: 'user_gender',
        label: 'Giới tính',
        placeholder: 'Giới tính',
        value: '1',
        error: '',
        isError: false,
        required: true,
        options: [
          {
            name: 'Nam',
            value: 1
          },
          {
            name: 'Nữ',
            value: 2
          },
          {
            name: 'Khác',
            value: 3
          }
        ],
        validations: ['required']
      },
      user_birthday: {
        id: 'user_birthday',
        label: 'Ngày sinh',
        placeholder: 'Ngày sinh',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'date']
      },
      user_addr: {
        id: 'user_addr',
        label: 'Địa chỉ',
        placeholder: 'Địa chỉ',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'maxLength', 254]
      },
      name_store: {
        id: 'name_store',
        label: 'Tên cửa hàng',
        placeholder: 'Tên cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
      code_store: {
        id: 'code_store',
        label: 'Mã cửa hàng',
        placeholder: 'Mã cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
      phone_store: {
        id: 'phone_store',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'phone']
      },
      addr_store: {
        id: 'addr_store',
        label: 'Địa chỉ cửa hàng',
        placeholder: 'Địa chỉ cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
    })
    const stepRegister = ref({
      1: {
        label: 'BƯỚC 1',
        iconText: '1',
        status: 2,
      },
      2: {
        label: 'BƯỚC 2',
        iconText: '2',
        status: 1,
      },
      3: {
        label: 'BƯỚC 3',
        iconText: '3',
        status: 1,
      },
      4: {
        label: 'BƯỚC 4',
        iconText: '4',
        status: 1,
      }
    })
    const step = ref(1)
    const errorMessage = ref([])
    const router = useRoute()

    function onChange(value, name) {
      dataRegister.value[name].value = value
    }

    function validateFormCompany(value, name) {
      const hasError = CommonService.validateForm(value, name, {
        name_company: dataRegister.value.name_company,
        code_company: dataRegister.value.code_company,
        phone_company: dataRegister.value.phone_company,
        email_company: dataRegister.value.email_company,
        addr_company: dataRegister.value.addr_company,
      })
      const field = dataRegister.value[name]
      if (!field) return hasError
      return hasError
    }
    function validateFormUser(value, name) {
      let hasError = CommonService.validateForm(value, name, {
        user_name: dataRegister.value.user_name,
        user_phone: dataRegister.value.user_phone,
        user_email: dataRegister.value.user_email,
        user_password: dataRegister.value.user_password,
        user_password_confirm: dataRegister.value.user_password_confirm,
        user_gender: dataRegister.value.user_gender,
        user_birthday: dataRegister.value.user_birthday,
        user_addr: dataRegister.value.user_addr
      })
      const field = dataRegister.value[name]
      if (!field) return hasError

      if (name === 'user_password_confirm' && dataRegister.value.user_password_confirm.value !== value) {
        field.isError = true
        field.error = ErrorMessageConstant.ERROR_PASSWORD_CONFIRM
        hasError = true
      }
      return hasError
    }
    function validateFormStore(value, name) {
      const hasError = CommonService.validateForm(value, name, {
        name_store: dataRegister.value.name_store,
        code_store: dataRegister.value.code_store,
        addr_store: dataRegister.value.addr_store,
        phone_store: dataRegister.value.phone_store
      })
      const field = dataRegister.value[name]
      if (!field) return hasError

      return hasError
    }

    async function registerAccount() {
      isLoading.value = true;
      const params = {
        company_name: dataRegister.value.name_company.value,
        company_zip: dataRegister.value.code_company.value,
        company_adr: dataRegister.value.addr_company.value,
        company_tel: dataRegister.value.phone_company.value,
        company_mail_address: dataRegister.value.email_company.value,
        user_name: dataRegister.value.user_name.value,
        mail_address: dataRegister.value.user_email.value,
        password: dataRegister.value.user_password.value,
        user_birth: dataRegister.value.user_birthday.value,
        user_gender: dataRegister.value.user_gender.value,
        user_phone: dataRegister.value.user_phone.value,
        user_addr: dataRegister.value.user_addr.value,
        name_store: dataRegister.value.name_store.value,
        code_store: dataRegister.value.code_store.value,
        phone_store: dataRegister.value.phone_store.value,
        addr_store: dataRegister.value.addr_store.value,
        token: router.query.token ?? ''
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/auth/register';
      const res = await companyStore.register(url, params);
      isLoading.value = false;
      const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
      if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
        errorMessage.value = errorMessageRes;
        step.value = 1
        stepRegister.value[1].status = 2
        stepRegister.value[2].status = 2
        stepRegister.value[3].status = 2
        stepRegister.value[4].status = 1
      }else {
        stepRegister.value[step.value].status = 3
        step.value++;
        stepRegister.value[step.value].status = 2
        errorMessage.value = []
      }
    }

    function nextStep() {
      if(step.value === 1) {
        errors.value = false
        for (const key in dataRegister.value) {
          const hasError = validateFormCompany(dataRegister.value[key].value, key)
          if (hasError) errors.value = true
        }
      }
      if(step.value === 2) {
        errors.value = false
        dataRegister.value.code_store.value = 'CUA_HANG_1';
        for (const key in dataRegister.value) {
          const hasError = validateFormUser(dataRegister.value[key].value, key)
          if (hasError) errors.value = true
        }
      }
      if(step.value === 3) {
        errors.value = false
        for (const key in dataRegister.value) {
          const hasError = validateFormStore(dataRegister.value[key].value, key)
          if (hasError) errors.value = true
        }
      }
      if(!errors.value) {
        if(step.value === 3) {
          registerAccount()
        }else {
          stepRegister.value[step.value].status = 3
          step.value++;
          stepRegister.value[step.value].status = 2
        }
      }
    }

    function backProcess() {
      stepRegister.value[step.value].status = 1
      step.value--;
      stepRegister.value[step.value].status = 2
    }

    function removeError(key) {
      errorMessage.value.splice(key, 1)
    }

    return {
      companyStore,
      errors,
      dataRegister,
      labelBtnRegister,
      labelBtnStep,
      stepRegister,
      labelBtnStepBack,
      labelBtnStepNext,
      step,
      errorMessage,
      isLoading,
      onChange,
      validateFormCompany,
      validateFormUser,
      backProcess,
      nextStep,
      removeError,
    }
  },
}
</script>
<style scoped lang="scss">
.container-fluid {
  .card-save {
    min-height: 100vh;
    display: flex;
    margin: 0 auto;
    background: url('@/assets/images/login.jpg') 50%;
    .layout-banner {
      align-items: center;
      justify-content: center;
      background: url('@/assets/images/background-register.jpg') center center / cover no-repeat;
      .banner-register {
        width: 450px;
        padding: 40px;
        margin: 0 auto;
      }
    }
    .layout-register {
      background-color: #fff;
      padding: 40px 20px;
      .title {
        margin-bottom: 50px;
      }
      .form-register {
        margin-top: 100px;
      }
    }
  }
}
@media (min-width: 992px) {
  .container-fluid {
    padding-right: 1rem;
    padding-left: 1rem;
  }
}
@media (min-width: 1440px) {
  .container-fluid {
    padding-right: 1rem;
    padding-left: 1rem;
  }
}

@media (max-width: 1024px) {
  .form-register {
    .card-body {
      padding: 0;
    }
  }
  .container-fluid {
    .card-save {
      .layout-banner {
        .banner-register {
          padding: 40px 20px;
          .fs-6 {
            font-size: 0.8rem !important;
          }
        }
      }
    }
  }
}
</style>
